/* eslint-disable array-callback-return */

import { Box, Button, Divider, Grid } from "@mui/material";
import { CSSProperties } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ValidationError from "../validation-error-label";
import Color from "../../theme/color";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers";

const TimeTable = ({
  style,
  onChangeDateTimeTable,
  validDateError,
  data,
  handleChangeInput,
  handleAddFields,
  handleRemoveFields,
  TimeZoneData,
}: TicketTableProps) => {
  const showAddButton = (index: number) => {
    if (data.length === 1) {
      return true;
    }
    if (data.length - 1 === index) {
      return true;
    }
    return false;
  };

  const showRemoveButton = (index: number) => {
    if (data.length === 1) {
      return false;
    }
    if (data.length - 1 === index) {
      return false;
    }
    return true;
  };
  const renderAddRemoveIngredient = (index: number) => {
    return (
      <Grid
        item
        xs={1}
        sm={1}
        md={1}
        justifyContent={"center"}
        display={"flex"}
        alignItems={"center"}
      >
        {showAddButton(index) ? (
          <Button
            onClick={() => handleAddFields()}
            variant="contained"
            style={{ backgroundColor: Color.green }}
          >
            <AddIcon />
          </Button>
        ) : null}
        {showRemoveButton(index) ? (
          <Button
            onClick={() => handleRemoveFields(index)}
            variant="contained"
            style={{ backgroundColor: Color.red }}
          >
            <DeleteForeverIcon />
          </Button>
        ) : (
          <>
            {showRemoveButton(index) === showRemoveButton(0) ? null : (
              <Button
                onClick={() => handleRemoveFields(index)}
                variant="contained"
                style={{
                  backgroundColor: Color.red,
                  marginLeft: 10,
                }}
              >
                <DeleteForeverIcon />
              </Button>
            )}
          </>
        )}
      </Grid>
    );
  };

  function addTimeToCurrentDate(timeString: string): Date | null {
    const [hours, minutes, seconds] = timeString.split(":").map((part) => {
      const parsedPart = parseInt(part, 10);
      return isNaN(parsedPart) ? 0 : parsedPart;
    });

    const currentDate = new Date();
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(seconds);

    return isNaN(currentDate.getTime()) ? null : currentDate;
  }
  const today = dayjs();

  const defaultTimeValue = today.endOf("day");
  return (
    <div>
      <Box
        style={{
          width: "100%",
        }}
      >
        {data.map((inputField: any, index: number) => {
          return (
            <>
              <Grid
                sx={{
                  width: "50%",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  marginBottom: data.length - 1 === index ? 0 : 2,
                }}
                container
                spacing={{ xs: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                key={index}
              >
                <Grid container xs={10} sm={10} md={10}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    style={{ marginInline: 5, marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "startDate ",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        disablePast
                        format="ll"
                        label="Start Date *"
                        value={dayjs(inputField.startDate)}
                        onChange={(event: any) =>
                          handleChangeInput(index, event, "", "startDate")
                        }
                      />
                    </LocalizationProvider>
                    {validDateError[`startDate-${index}`] && (
                      <ValidationError
                        formErrors={validDateError[`startDate-${index}`]}
                      />
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2.5}
                    style={{ marginInline: 5, marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        defaultValue={defaultTimeValue}
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "startTime",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        timezone="default"
                        value={dayjs(
                          addTimeToCurrentDate(inputField.startTime)
                        )}
                        label="Start Time *"
                        onChange={(event) =>
                          handleChangeInput(index, event, "", "startTime")
                        }
                      />
                    </LocalizationProvider>
                    {validDateError[`startTime-${index}`] && (
                      <ValidationError
                        formErrors={validDateError[`startTime-${index}`]}
                      />
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    style={{ marginInline: 5, marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "endDate",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        disablePast
                        format="ll"
                        label="End Date *"
                        value={dayjs(inputField.endDate)}
                        onChange={(event: any) =>
                          handleChangeInput(index, event, "", "endDate")
                        }
                      />
                    </LocalizationProvider>
                    {validDateError[`endDate-${index}`] && (
                      <ValidationError
                        formErrors={validDateError[`endDate-${index}`]}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2.5}
                    style={{ marginInline: 5, marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        defaultValue={defaultTimeValue}
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "endTime",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        onChange={(event: any) =>
                          handleChangeInput(index, event, "", "endTime")
                        }
                        value={dayjs(addTimeToCurrentDate(inputField.endTime))}
                        label="End Time *"
                      />
                    </LocalizationProvider>
                    {validDateError[`endTime-${index}`] && (
                      <ValidationError
                        formErrors={validDateError[`endTime-${index}`]}
                      />
                    )}
                  </Grid>
                  {/* <Grid
                    item
                    xs={5.5}
                    sm={5.5}
                    md={2.6}
                    style={{ marginInline: 2, marginBlock: 5 }}
                  >
                    <AutoCompleteDropDown
                      data={TimeZoneData}
                      onChange={async (newValue) => {
                        await handleChangeInput(
                          index,
                          newValue,
                          "timezone",
                          "timezone"
                        );
                      }}
                      label={"timeZoneName"}
                      value={inputField?.timezone}
                      dropDownDisplayLabel={"Time Zone"}
                    />
                    {validDateError[`timezone-${index}`] && (
                      <ValidationError
                        formErrors={validDateError[`timezone-${index}`]}
                      />
                    )}
                  </Grid> */}
                </Grid>

                <Grid
                  xs={12}
                  sm={12}
                  md={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {renderAddRemoveIngredient(index)}
                </Grid>
              </Grid>
              {data?.length > 1 && data.length - 1 !== index ? (
                <Divider sx={{ marginBottom: 2.2 }} />
              ) : null}
            </>
          );
        })}
      </Box>
    </div>
  );
};

export default TimeTable;
interface TicketTableProps {
  TimeZoneData: any;
  style?: CSSProperties | undefined;
  onChangeDateTimeTable: (newValue: any) => void;
  validDateError?: any;
  handleChangeInput: (
    index: number,
    event: any,
    timezone?: string,
    name?: string
  ) => void;
  handleAddFields: () => void;
  handleRemoveFields: (index: number) => void;
  data?: any;
}
